import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import "./NotFound.scss";

function NotFound() {
  return (
    <>
      <NavBar />
      <div className="notFound">
        <span className="eyebrow">Error 404</span>
        <h1 className="section-heading">Page not found</h1>
        <p className="lede">
          The page you're looking for doesn't exist or has moved.
        </p>
        <Link to="/" className="btn btn--filled">Back to Home</Link>
      </div>
      <Footer />
    </>
  );
}

export default NotFound;
